import { useContext } from 'react';
import { createContext } from 'react';

import { SearchNotFoundLayoutProps } from '../@types/SearchNotFoundLayoutProps';

export const SearchNotFoundLayoutContext = createContext<SearchNotFoundLayoutProps>({} as SearchNotFoundLayoutProps);

SearchNotFoundLayoutContext.displayName = 'SearchNotFoundLayout';

const SearchNotFoundLayoutProvider = (props: SearchNotFoundLayoutProps) => (
	<SearchNotFoundLayoutContext.Provider value={props}>{props.children}</SearchNotFoundLayoutContext.Provider>
);

export const useSearchNotFoundLayout = () => {
	const context = useContext(SearchNotFoundLayoutContext);

	return context;
};

export default SearchNotFoundLayoutProvider;
